export default "__VITE_ASSET__DDG83hUX__"